<div class="message" [class.warn]="warning()">
    <app-icon [icon]="icon()"></app-icon>
    <span>{{ displayText() }}</span>
</div>
